var $957b8ea559115f07$exports = {};
// Esse script serve para a versão mobile. Ao clicar no botao hambuerguer, o menu que ficava escondido passa a ficar visivel.
const $957b8ea559115f07$var$hamburguerDiv = document.querySelector(".header__hamburguer");
const $957b8ea559115f07$var$hamburguerImage = document.querySelector(".header__hamburguer img");
const $957b8ea559115f07$var$navEl = document.querySelector(".header__nav");
const $957b8ea559115f07$var$heroSection = document.querySelector(".section-hero");
const $957b8ea559115f07$var$mainEl = document.querySelector("main");
const $957b8ea559115f07$var$footerEl = document.querySelector("footer");
$957b8ea559115f07$var$hamburguerDiv.addEventListener("click", function(e) {
    $957b8ea559115f07$var$hamburguerDiv.classList.toggle("header__hamburguer--inativo");
    $957b8ea559115f07$var$navEl.classList.toggle("header__nav--modal");
    $957b8ea559115f07$var$heroSection.classList.toggle("section-hero--modal");
    $957b8ea559115f07$var$mainEl.classList.toggle("display-none");
    $957b8ea559115f07$var$footerEl.classList.toggle("display-none");
    // Get the current page scroll position
    // scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // (scrollLeft = window.pageXOffset || document.documentElement.scrollLeft),
    //   //     // if any scroll is attempted, set this to the previous value
    //   (window.onscroll = function () {
    //     window.scrollTo(scrollLeft, scrollTop);
    //   });
    window.scrollTo(0, 0);
}); // heroSection.addEventListener("touchstart", function (e) {
 //   console.log("ok");
 //   e.preventDefault();
 //   e.stopPropagation();
 // });


//# sourceMappingURL=index.8db66fc4.js.map
